import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { companyLogo, companyOptionsNumber } from '../../../constants/companies';
import {
  moneyFormatterEur,
  moneyFormatterMDL,
} from '../../../helpers/moneyFormatted';
import { Text18 } from '../../../ui/Text18';
import { 
  Company, 
  InsuranceParameters, 
  Offers, 
  IInsurance,
  SetInsurance,
  SetInsuranceParameters 
} from '../../../types';
import { 
  CardWrapper, 
  CardHeaderItem,
  CardHeaderLogo,
  InsuranceSumWrapper,
  InsuranceSum,
  InsuranceSumOptions,
  CardInfo,
  ButtonWrapper,
  BuyButton
} from '../style';

type Props = {
  company: Company;
  offer: Offers;
  insurance:  IInsurance;
  insuranceParameters: InsuranceParameters;
  setInsurance: SetInsurance;
  setInsuranceParameters: SetInsuranceParameters; 
};
const CardHeader: React.FC<Props> = ({
  offer,
  company,
  insurance,
  insuranceParameters,
  setInsurance,
  setInsuranceParameters
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const insuranceSum = moneyFormatterEur.format(offer.sum);
  const insurancePrice = moneyFormatterMDL.format(offer.amount.mdl);

  const handleNavigate = () => {
    setInsuranceParameters({
      ...insuranceParameters,
      selectedInsurance: {
        name: company.name,
        sum: offer.sum,
        logo: company.logo,
      }      
    });
    
    setInsurance({
      ...insurance,
      details: {
        ...insurance.details,
        insurance_company: company.name
      }
    });
    
    navigate('/buy-insurance');
  };

  return (
    <CardWrapper>
      <CardHeaderItem>
        <CardHeaderLogo src={companyLogo[company.name]} />
      </CardHeaderItem>
      <CardHeaderItem>
        <InsuranceSumWrapper>
          <InsuranceSum>
            {insuranceSum}
            <CardInfo />
          </InsuranceSum>
          <InsuranceSumOptions>{`${t('insurance_summ')} + ${companyOptionsNumber[company.name]} ${t(
            'options'
          )}`}</InsuranceSumOptions>
        </InsuranceSumWrapper>
      </CardHeaderItem>
      <ButtonWrapper>
        <BuyButton variant='contained' onClick={handleNavigate}>
          <Text18 style={{ fontWeight: 700, textTransform: 'none' }}>{`${t(
            'buy_for'
          )} ${insurancePrice}`}</Text18>
        </BuyButton>
      </ButtonWrapper>
    </CardWrapper>
  );
};

export default CardHeader;
